// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Checkbox from "components/layout/Checkbox";

// #####################################################

const CheckboxSelectAll = ({
	onChange,
	withActiveBackgroundColor = false,
	...props
}) => {
	const { t } = useTranslation(["common"]);
	const label = t("selectAll");
	return (
		<Checkbox
			label={label}
			onChange={(e) => {
				if (typeof onChange === "function") {
					onChange(e);
				}

				if (withActiveBackgroundColor) {
					const allElements =
						document.querySelectorAll("[data-tableRowId]");

					if (props?.checked) {
						allElements.forEach((element) => {
							element.removeAttribute("data-rowActive");
						});
					} else {
						allElements.forEach((element) => {
							element.setAttribute("data-rowActive", "true");
						});
					}
				}
			}}
			{...props}
		/>
	);
};

export default CheckboxSelectAll;

// #####################################################
